import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LandingPageComponent} from './landing-page.component';

const routes: Routes = [
    {
        path: '',
        component: LandingPageComponent,
        data: {animation: 'landing-page'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class LandingPageRoutingModule {
}
